/* Formatting shared by the purchase-flow screens. Mirrors the prototype's
   helpers so figures read identically to the design. */

// Money in any store currency: one formatter, shared with the brand and
// category pages (utils/currency.js).
import { formatMoney, currencySymbol } from "./currency";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "₹", "$", "€", or "CHF " for a currency without a symbol. */
export const symbolFor = (currencyType) => currencySymbol(currencyType);

/**
 * "₹1,220" — the prototype's rupee(). Rupees round to whole numbers; any
 * other currency keeps its decimals when there are any ("$9.99", "$12",
 * "€9.50", "¥1,499", "CHF 12.50").
 */
export const money = (n, currencyType) => formatMoney(n, currencyType);

/** "3 Sep" */
export const shortDate = (input) => {
  if (!input) return "";
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
};

/** "3 Sep 2027" */
export const longDate = (input) => {
  if (!input) return "";
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

/** "3 Sep 2026, 9:41 pm" */
export const dateTime = (input) => {
  if (!input) return "";
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  let h = d.getHours();
  const suffix = h >= 12 ? "pm" : "am";
  h = h % 12 || 12;
  const m = String(d.getMinutes()).padStart(2, "0");
  return `${longDate(d)}, ${h}:${m} ${suffix}`;
};

/** "+91 98•••••210" */
export const maskPhone = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "").slice(-10);
  if (digits.length < 10) return raw ? String(raw) : "";
  return `+91 ${digits.slice(0, 2)}•••••${digits.slice(-3)}`;
};

export const initialOf = (name) => (String(name || "").trim().charAt(0) || "?").toUpperCase();
